import * as FiIcons from 'react-icons/fi';

export const services = [
  {
    icon: FiIcons.FiZap,
    number: '01',
    title: 'AI Automation Workflows',
    text: 'We design and build intelligent automation workflows that connect your business systems, eliminate manual repetitive tasks, and streamline operations end-to-end.'
  },
  {
    icon: FiIcons.FiCpu,
    number: '02',
    title: 'Agentic Workflows',
    text: 'We build autonomous agent-driven workflows that can reason, make decisions, and take action across your tools and platforms with minimal human intervention.'
  },
  {
    icon: FiIcons.FiCode,
    number: '03',
    title: 'Software Development',
    text: 'We build custom applications, integrations, and APIs that are maintainable, scalable, and built to last.'
  },
  {
    icon: FiIcons.FiSearch,
    number: '04',
    title: 'Expert Advisory & IT Tools Review',
    text: 'We assess your existing processes, tools, and workflows, then provide clear recommendations on what to keep, replace, and automate.'
  }
];

export const processSteps = [
  {
    number: '01',
    title: 'Understand',
    text: 'We assess your current processes, systems, and goals to identify where technology can create the greatest impact.'
  },
  {
    number: '02',
    title: 'Recommend',
    text: 'We provide clear, actionable recommendations focused on solving root problems—not selling tools you do not need.'
  },
  {
    number: '03',
    title: 'Build',
    text: 'We develop and integrate practical software, automations, APIs, and AI workflows around your real business needs.'
  },
  {
    number: '04',
    title: 'Support',
    text: 'We stay close to the systems we build and provide senior-level attention as your business and technology evolve.'
  }
];

export const outcomes = [
  {
    value: 'AI',
    label: 'automation built around your actual workflows'
  },
  {
    value: '24/7',
    label: 'digital workers for repetitive multi-step processes'
  },
  {
    value: '1:1',
    label: 'senior-level attention from start to finish'
  }
];